module.exports = __webpack_public_path__ + "img5.d1c3d18.png";